(function(){
'use strict';
/* Shared Directory Map Component
   Works with both __RSD_DATA (has lat/lng) and __CSD_DATA (city-level) */

var CITY_COORDS={};
var map=null,markers=[],userMarker=null,mapLoaded=false;
var storeType=''; // 'vinyl' or 'coffee'
var storeData=[];
var searchInput=null;

/* === CITY COORDINATES (top ~100 US cities) === */
var CC={"birmingham_al":[33.52,-86.81],"huntsville_al":[34.73,-86.59],"mobile_al":[30.70,-88.04],"anchorage_ak":[61.22,-149.90],"phoenix_az":[33.45,-112.07],"tucson_az":[32.22,-110.93],"mesa_az":[33.42,-111.83],"tempe_az":[33.43,-111.94],"scottsdale_az":[33.49,-111.93],"little rock_ar":[34.75,-92.29],"los angeles_ca":[34.05,-118.24],"san francisco_ca":[37.77,-122.42],"san diego_ca":[32.72,-117.16],"san jose_ca":[37.34,-121.89],"sacramento_ca":[38.58,-121.49],"oakland_ca":[37.80,-122.27],"long beach_ca":[33.77,-118.19],"fresno_ca":[36.75,-119.77],"santa ana_ca":[33.75,-117.87],"anaheim_ca":[33.84,-117.91],"berkeley_ca":[37.87,-122.27],"pasadena_ca":[34.15,-118.14],"santa cruz_ca":[36.97,-122.03],"denver_co":[39.74,-104.98],"colorado springs_co":[38.83,-104.82],"boulder_co":[40.01,-105.27],"fort collins_co":[40.59,-105.08],"hartford_ct":[41.76,-72.68],"new haven_ct":[41.31,-72.92],"wilmington_de":[39.74,-75.55],"washington_dc":[38.91,-77.04],"miami_fl":[25.76,-80.19],"orlando_fl":[28.54,-81.38],"tampa_fl":[27.95,-82.46],"jacksonville_fl":[30.33,-81.66],"st. petersburg_fl":[27.77,-82.64],"fort lauderdale_fl":[26.12,-80.14],"tallahassee_fl":[30.44,-84.28],"atlanta_ga":[33.75,-84.39],"savannah_ga":[32.08,-81.09],"athens_ga":[33.96,-83.38],"honolulu_hi":[21.31,-157.86],"boise_id":[43.62,-116.20],"chicago_il":[41.88,-87.63],"springfield_il":[39.78,-89.65],"indianapolis_in":[39.77,-86.16],"bloomington_in":[39.17,-86.53],"des moines_ia":[41.59,-93.62],"iowa city_ia":[41.66,-91.53],"wichita_ks":[37.69,-97.34],"lawrence_ks":[38.97,-95.24],"louisville_ky":[38.25,-85.76],"lexington_ky":[38.05,-84.50],"new orleans_la":[29.95,-90.07],"baton rouge_la":[30.45,-91.19],"portland_me":[43.66,-70.26],"baltimore_md":[39.29,-76.61],"boston_ma":[42.36,-71.06],"cambridge_ma":[42.37,-71.11],"detroit_mi":[42.33,-83.05],"ann arbor_mi":[42.28,-83.74],"grand rapids_mi":[42.96,-85.67],"minneapolis_mn":[44.98,-93.27],"st. paul_mn":[44.95,-93.09],"jackson_ms":[32.30,-90.18],"kansas city_mo":[39.10,-94.58],"st. louis_mo":[38.63,-90.20],"omaha_ne":[41.26,-95.94],"lincoln_ne":[40.81,-96.70],"las vegas_nv":[36.17,-115.14],"reno_nv":[39.53,-119.81],"manchester_nh":[42.99,-71.46],"newark_nj":[40.74,-74.17],"jersey city_nj":[40.73,-74.04],"hoboken_nj":[40.74,-74.03],"albuquerque_nm":[35.08,-106.65],"santa fe_nm":[35.69,-105.94],"new york_ny":[40.71,-74.01],"brooklyn_ny":[40.68,-73.94],"buffalo_ny":[42.89,-78.88],"rochester_ny":[43.16,-77.61],"syracuse_ny":[43.05,-76.15],"charlotte_nc":[35.23,-80.84],"raleigh_nc":[35.78,-78.64],"durham_nc":[35.99,-78.90],"asheville_nc":[35.60,-82.55],"fargo_nd":[46.88,-96.79],"columbus_oh":[39.96,-82.99],"cleveland_oh":[41.50,-81.69],"cincinnati_oh":[39.10,-84.51],"dayton_oh":[39.76,-84.19],"oklahoma city_ok":[35.47,-97.52],"tulsa_ok":[36.15,-95.99],"portland_or":[45.52,-122.68],"eugene_or":[44.05,-123.09],"philadelphia_pa":[39.95,-75.17],"pittsburgh_pa":[40.44,-80.00],"providence_ri":[41.82,-71.41],"charleston_sc":[32.78,-79.93],"columbia_sc":[34.00,-81.03],"nashville_tn":[36.16,-86.78],"memphis_tn":[35.15,-90.05],"knoxville_tn":[35.96,-83.92],"austin_tx":[30.27,-97.74],"houston_tx":[29.76,-95.37],"dallas_tx":[32.78,-96.80],"san antonio_tx":[29.42,-98.49],"fort worth_tx":[32.76,-97.33],"el paso_tx":[31.76,-106.44],"salt lake city_ut":[40.76,-111.89],"burlington_vt":[44.48,-73.21],"richmond_va":[37.54,-77.44],"virginia beach_va":[36.85,-75.98],"norfolk_va":[36.85,-76.29],"seattle_wa":[47.61,-122.33],"tacoma_wa":[47.25,-122.44],"spokane_wa":[47.66,-117.43],"milwaukee_wi":[43.04,-87.91],"madison_wi":[43.07,-89.40]};

/* Also include international cities */
var INTL={"london_england":[51.51,-0.13],"manchester_england":[53.48,-2.24],"liverpool_england":[53.41,-2.98],"edinburgh_scotland":[55.95,-3.19],"glasgow_scotland":[55.86,-4.25],"dublin_ireland":[53.35,-6.26],"paris_france":[48.86,2.35],"berlin_germany":[52.52,13.40],"amsterdam_netherlands":[52.37,4.90],"barcelona_spain":[41.39,2.17],"madrid_spain":[40.42,-3.70],"rome_italy":[41.90,12.50],"tokyo_japan":[35.68,139.69],"melbourne_australia":[37.81,144.96],"sydney_australia":[33.87,151.21],"toronto_on":[43.65,-79.38],"vancouver_bc":[49.28,-123.12],"montreal_qc":[45.50,-73.57],"mexico city_mexico":[19.43,-99.13]};
for(var k in INTL) CC[k]=INTL[k];
CITY_COORDS=CC;

function detectType(){
  if(window.__RSD_DATA && !window.__CSD_DATA) return 'vinyl';
  if(window.__CSD_DATA && !window.__RSD_DATA) return 'coffee';
  return 'both';
}

function getStores(){
  var type = detectType();
  storeType = type;
  var raw = [];
  if(window.__RSD_DATA){
    for(var i=0;i<window.__RSD_DATA.length;i++){
      var s=window.__RSD_DATA[i];
      raw.push({name:s[1],city:s[2],state:s[3],country:s[4],lat:parseFloat(s[10]),lng:parseFloat(s[11]),type:'vinyl'});
    }
  }
  if(window.__CSD_DATA){
    for(var i=0;i<window.__CSD_DATA.length;i++){
      var s=window.__CSD_DATA[i];
      raw.push({name:s[1],city:s[2],state:s[3],country:s[4]||'us',lat:null,lng:null,type:'coffee'});
    }
  }
  return raw;
}

function buildCityData(stores){
  var cities={};
  for(var i=0;i<stores.length;i++){
    var s=stores[i];
    var key=(s.city+'_'+s.state).toLowerCase().trim();
    if(!cities[key]) cities[key]={city:s.city,state:s.state,vinyl:0,coffee:0,total:0,lat:null,lng:null};
    if(s.type==='vinyl') cities[key].vinyl++;
    else cities[key].coffee++;
    cities[key].total++;
    if(s.lat && s.lng && !cities[key].lat){cities[key].lat=s.lat;cities[key].lng=s.lng;}
    if(!cities[key].lat && CITY_COORDS[key]){cities[key].lat=CITY_COORDS[key][0];cities[key].lng=CITY_COORDS[key][1];}
  }
  return cities;
}

function getMarkerColor(d){
  if(storeType==='vinyl') return {bg:'#7c5cfc',glow:'rgba(124,92,252,0.5)'};
  if(storeType==='coffee') return {bg:'#ff6b35',glow:'rgba(255,107,53,0.5)'};
  if(d.vinyl>0&&d.coffee>0) return {bg:'#ffd166',glow:'rgba(255,209,102,0.5)'};
  if(d.vinyl>0) return {bg:'#7c5cfc',glow:'rgba(124,92,252,0.5)'};
  return {bg:'#ff6b35',glow:'rgba(255,107,53,0.5)'};
}

function initMap(){
  var el=document.getElementById('dir-map');
  if(!el||typeof L==='undefined') return;
  map=L.map('dir-map',{zoomControl:false,attributionControl:false,scrollWheelZoom:false}).setView([39.8,-98.5],4);
  L.control.zoom({position:'bottomright'}).addTo(map);
  L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',{maxZoom:19,subdomains:'abcd'}).addTo(map);
  el.addEventListener('mouseenter',function(){map.scrollWheelZoom.enable()});
  el.addEventListener('mouseleave',function(){map.scrollWheelZoom.disable()});
  mapLoaded=true;
  updateMarkers();
}

function updateMarkers(){
  if(!map||!mapLoaded) return;
  for(var i=0;i<markers.length;i++) map.removeLayer(markers[i]);
  markers=[];
  var stores=getStores();
  if(!stores.length) return;
  var cities=buildCityData(stores);
  var keys=Object.keys(cities);
  for(var i=0;i<keys.length;i++){
    var d=cities[keys[i]];
    if(!d.lat||!d.lng) continue;
    var c=getMarkerColor(d);
    var sz=Math.min(14+Math.sqrt(d.total)*4,40);
    var icon=L.divIcon({className:'dir-marker-glow',html:'<div class="dir-glow-dot" style="width:'+sz+'px;height:'+sz+'px;background:'+c.bg+';box-shadow:0 0 '+sz/2+'px '+c.glow+',0 0 '+sz+'px '+c.glow+'">'+d.total+'</div>',iconSize:[sz,sz],iconAnchor:[sz/2,sz/2]});
    var tip='<strong>'+d.city+', '+d.state+'</strong><span class="dir-tip-stats">';
    if(d.vinyl) tip+='<span style="color:#7c5cfc">\u25CF</span> '+d.vinyl+' vinyl';
    if(d.vinyl&&d.coffee) tip+=' \u00B7 ';
    if(d.coffee) tip+='<span style="color:#ff6b35">\u25CF</span> '+d.coffee+' coffee';
    tip+='</span>';
    var m=L.marker([d.lat,d.lng],{icon:icon}).addTo(map);
    m.bindTooltip(tip,{className:'dir-dark-tooltip',direction:'top',offset:[0,-sz/2-4]});
    (function(dd,mk){
      var dot=mk.getElement();
      if(dot){
        dot.addEventListener('mouseenter',function(){
          var el=dot.querySelector('.dir-glow-dot');
          if(el){el.style.transform='scale(1.3)';el.style.boxShadow='0 0 20px '+getMarkerColor(dd).glow+',0 0 40px '+getMarkerColor(dd).glow+',0 0 60px '+getMarkerColor(dd).glow;}
        });
        dot.addEventListener('mouseleave',function(){
          var el=dot.querySelector('.dir-glow-dot');
          if(el){var cc=getMarkerColor(dd);var ssz=Math.min(14+Math.sqrt(dd.total)*4,40);el.style.transform='scale(1)';el.style.boxShadow='0 0 '+ssz/2+'px '+cc.glow+',0 0 '+ssz+'px '+cc.glow;}
        });
      }
      mk.on('click',function(){
        if(searchInput){searchInput.value=dd.city;searchInput.dispatchEvent(new Event('input',{bubbles:true}));}
        map.flyTo([dd.lat,dd.lng],8,{duration:1});
      });
    })(d,m);
    markers.push(m);
  }
}

function locateMe(){
  if(!map) return;
  var btn=document.getElementById('dir-locate-btn');
  if(btn){btn.classList.add('dir-locate--active');btn.querySelector('.dir-locate__text').textContent='Locating...';}
  if(!navigator.geolocation){if(btn){btn.classList.remove('dir-locate--active');btn.querySelector('.dir-locate__text').textContent='Not supported';}return;}
  navigator.geolocation.getCurrentPosition(function(pos){
    var lat=pos.coords.latitude,lng=pos.coords.longitude;
    map.flyTo([lat,lng],8,{duration:1});
    if(userMarker) map.removeLayer(userMarker);
    userMarker=L.marker([lat,lng],{icon:L.divIcon({className:'dir-marker-glow',html:'<div class="dir-user-marker"><div class="dir-user-marker__dot"></div><div class="dir-user-marker__ring"></div></div>',iconSize:[20,20],iconAnchor:[10,10]})}).addTo(map);
    if(btn){btn.classList.remove('dir-locate--active');btn.querySelector('.dir-locate__text').textContent='Locate Me';}
    var best=null,bestD=Infinity;
    var ck=Object.keys(CITY_COORDS);
    for(var i=0;i<ck.length;i++){var c=CITY_COORDS[ck[i]];var dx=c[0]-lat,dy=c[1]-lng;var dd=dx*dx+dy*dy;if(dd<bestD){bestD=dd;best=ck[i];}}
    if(best&&bestD<4&&searchInput){var cn=best.split('_')[0];cn=cn.charAt(0).toUpperCase()+cn.slice(1);searchInput.value=cn;searchInput.dispatchEvent(new Event('input',{bubbles:true}));}
  },function(){
    if(btn){btn.classList.remove('dir-locate--active');btn.querySelector('.dir-locate__text').textContent='Locate Me';}
  },{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
}

function toggleMap(){var wrap=document.querySelector(".dir-map-wrap");var btn=document.getElementById("dir-map-toggle");if(!wrap||!btn)return;if(wrap.classList.contains("dir-map--hidden")){wrap.classList.remove("dir-map--hidden");btn.classList.add("is-active");btn.title="Hide Map";if(map)setTimeout(function(){map.invalidateSize()},200);}else{wrap.classList.add("dir-map--hidden");btn.classList.remove("is-active");btn.title="Show Map";}}
function init(){
  searchInput=document.querySelector('.rsd-search__input')||document.querySelector('.csd-search__input')||document.querySelector('#rsd-search')||document.querySelector('#csd-search')||document.querySelector('input[placeholder*="Search"]');
  var toggleBtn=document.getElementById('dir-map-toggle');
  if(toggleBtn) toggleBtn.addEventListener('click',toggleMap);
  var locateBtn=document.getElementById('dir-locate-btn');
  if(locateBtn) locateBtn.addEventListener('click',locateMe);
  
  // Load Leaflet CSS
  var link=document.createElement('link');
  link.rel='stylesheet';
  link.href='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  document.head.appendChild(link);
  
  // Load Leaflet JS then init map
  var script=document.createElement('script');
  script.src='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  script.onload=function(){
    // Wait for data to be ready
    var tries=0;
    var poll=setInterval(function(){
      tries++;
      if(window.__RSD_DATA||window.__CSD_DATA||tries>50){
        clearInterval(poll);
        initMap();
      }
    },200);
  };
  document.head.appendChild(script);
}

if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
else init();
})();